/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { BaseModal, Button } from 'yankees-react-utils';
import { useOktaAuth } from '@okta/okta-react';
import { VideoSearch } from '../../data';

const DeleteSavedSearchModal = ({ showModal, setShowModal, modalContainer, savedSearch, onDelete }) => {
    const { t: translate } = useTranslation();
    const { authState: { accessToken } } = useOktaAuth();

    const [isLoading, setIsLoading] = useState(false);

    const deleteSearch = async () => {
        try {
            setIsLoading(true);

            await VideoSearch.delete(accessToken, savedSearch.VideoSearchID);
            onDelete(savedSearch);

            setShowModal(false);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <BaseModal
            show={showModal}
            onHide={() => setShowModal(false)}
            container={modalContainer}
        >
            <BaseModal.Header>
                {translate('sections.video-playlists.confirm-delete')}
            </BaseModal.Header>
            <BaseModal.Body>
                {translate('sections.video-playlists.confirm-delete-prompt', { name: savedSearch.Name })}
            </BaseModal.Body>
            <BaseModal.Footer>
                <Button onClick={() => setShowModal(false)}>{translate('common.cancel')}</Button>
                <Button variant="primary" onClick={deleteSearch} disabled={isLoading}>{translate('common.delete')}</Button>
            </BaseModal.Footer>
        </BaseModal>
    );
};

DeleteSavedSearchModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    setShowModal: PropTypes.func.isRequired,
    modalContainer: PropTypes.any.isRequired,
    savedSearch: PropTypes.object,
    onDelete: PropTypes.func.isRequired,
};

DeleteSavedSearchModal.defaultProps = {
    savedSearch: null,
};

export default DeleteSavedSearchModal;
